var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MobileSidebar',{attrs:{"items":_vm.items,"is-opened":_vm.isMobileSidebarOpened},on:{"close":_vm.closeMobileSidebar}})}
var staticRenderFns = []

export { render, staticRenderFns }